import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { rutaEgresos } from '../_egresos.js';

/**
 * Vive dentro del grupo `_egresos`, así que el guardián ya se aplicó y esta ruta no repite
 * ninguna verificación.
 *
 * El componente llega a pedido, con lo que arrastra: `@tanstack/query`, el formulario y la capa de
 * adjuntos con su compresor. El operario que solo cuenta efectivo no descarga nada de eso.
 */
export const rutaRegistroEgreso = createRoute({
  getParentRoute: () => rutaEgresos,
  path: '/egresos',
  component: lazyRouteComponent(() => import('./egresos-pantalla.js'), 'RutaEgresos'),
});
